import moment from 'moment-timezone';
import Config from 'config';

/**
 * Date/time strings are returned from V2 Search in a different format from V1.
 * (They contain seconds and have time zones applied.)
 * This formats a date time string in the context of a provided time zone
 * so we can limit the downstream effects inside this application.
 *
 * @function formatDateTime
 * @see {@link https://api.spothero.com/v2/docs#operation/searchTransientParking|Documentation}
 * @param {string} dateTimeString - A date time string that is ISO-8601 compliant.
 * @param {string} timezone - A time zone string, e.g. America/Chicago.
 * @param {string} outputFormat - Format for the output; defaults to YYYY-MM-DDTHH:mm.
 * I don't believe this is part of ISO-8601; it may be coupled to https://momentjs.com/timezone/
 * @returns {string} The formatted date time string that the rest of the application expects.
 */
export const formatDateTime = (
    dateTimeString,
    timezone,
    outputFormat = Config.apiDateTimeFormat
) => {
    return moment.tz(dateTimeString, timezone).format(outputFormat);
};
